import { RequestBuilder, fetchAndRetryIfServerBusy } from '@cvent/nucleus-networking';
import { ServiceError } from '../utils/errors';

/**
 * The capacity service client.
 */
export default class CapacityClient {
  constructor(baseURL, eventId, environment) {
    this.capacityBaseUrl = baseURL + 'capacity/v1';
    this.environment = environment;
    this.request = new RequestBuilder({ url: this.capacityBaseUrl }).withCookies();
    this.request = this.request.header('Content-Type', 'application/json')
      .header('Cvent-Event-ID', eventId);
  }

  /**
   * Retrieves the capacity summaries for each of the provided capacity ids.
   */
  async getCapacitySummaries(authToken, capacityIds) {
    const request = this.request
      .url(`${this.capacityBaseUrl}/metadatabulk/availableCount`)
      .query('environment', this.environment)
      .post()
      .auth(authToken)
      .json(capacityIds)
      .build();
    const response = await fetchAndRetryIfServerBusy(request);
    if (!response.ok) {
      throw await ServiceError.create('getCapacitySummaries failed', response, request);
    }
    return await response.json();
  }
}
